import * as lazyComponents from './components'
import { usePreloadLazy } from './utils'

export const usePreloadLazyComponents = (delay?: number) =>
  usePreloadLazy(Object.values(lazyComponents), delay)

export * from './components'
